import { Filter as FoundationFilter, foundationFilterStyles as styles, } from '@genesislcap/foundation-ui';
import { zeroFilterTemplate as template } from './filter.template';
/**
 * @tagname %%prefix%%-filter
 */
export class Filter extends FoundationFilter {
}
export const zeroFilter = Filter.compose({
    baseName: 'filter',
    template,
    styles,
});
